import axios from 'axios'

export const $authUser = axios.create({
    headers: {
        Authorization: 'Bearer 4vD2Yw@EfYn=5JLbw=Yt6Fj7d'
    },
    baseURL: process.env.VUE_APP_ALERUS_API_URL
})

export const $secureNowUser = axios.create({
    headers: {
        Authorization: 'Bearer E37KjFU7MPvnJdkB5NHkR2+QR//136rDowOkrBBo5uB1jE7hoD6LZwL6vy9yNv46YDHWol7pQZQ35ihEy3g/CBfuPslapxGIu+YLfS85O3I='
    },
    // baseURL: 'https://api.alerus.com'
})

export const $unAuthUser = axios.create({
    baseURL: process.env.VUE_APP_APPSYNC_API_URL
})
